<template>
    <b-row class="b-row">
        <b-col cols="3" v-if="!noLabels">
            <dd class="b-col">
                {{ xi18n(i8nPrefix, displayDataField.name) }}
            </dd>
        </b-col>
        <b-col>
            <dt class="b-col">{{ displayDataField.value }}</dt>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        props: {
            displayDataField: { type: Object, required: true },
            noLabels: { type: Boolean },
            i8nPrefix: { type: String, default: '' }
        },
        data() {
            return { rotate: 0 };
        },
        computed: {},
        methods: {}
    };
</script>
